import axios from 'axios'
import utils from './utils'
import qs from 'qs'


const processenv = process.env.NODE_ENV;//production或development

// axios 配置
var baseURL = '/api'  //dev时，与跨域配置config/index.js一致
if(processenv=="production"){
    // 生产环境(部署相同域名，无需跨域)
    baseURL="https://ovege.cn";
}
var contentType = 'application/x-www-form-urlencoded;charset=UTF-8';//'application/json;charset=UTF-8';//
var env=utils.getEnv();//mp:1,android:2,ios:3
var channel = env==1?32:(env==2?82:81);//32=微信小程序，81=APP-IOS，82=APP-ANDROID
var language = "en";
// axios.defaults.baseURL = baseURL;
// axios.defaults.timeout = 5000;
// axios.defaults.headers.post['Content-Type'] = contentType;
// axios.defaults.headers.common['cl-opchannel'] = channel;



export default {

    // options中包含着数据
    request:function(options) {
        
        return new Promise((resolve, reject) => {
            
            // var params = options.params;//?深拷贝
            // var sign_str = "";//tools.sign(params); //签名

            //处理url（两段）
            var baseURL="";
            // if(options.url.startsWith('http')){
            //     baseURL=options.url.substring(0,options.url.indexOf("/",10));
            //     options.url=options.url.substring(options.url.indexOf("/",10));
            //     console.log(baseURL, options.url);
            // }

            const instance = axios.create({
                baseURL: baseURL,
                timeout: 8000,
                withCredentials: true, //携带凭证信息,当设置为 true 时，请求会携带：Cookies（包括会话Cookie）, HTTP认证信息（如Basic Auth）,TLS客户端证书
                //instance创建一个axios实例，可以自定义配置，可在 axios文档中查看详情
                //所有的请求都会带上这些配置，比如全局都要用的身份信息等。
                headers: { //所需的信息放到header头中
                    "Content-Type": contentType,
                    // "X-LOCALE":language,
                    // "cl-opchannel":channel
                },
            });

            // 参数处理
            // let urlParams = new URLSearchParams();
            // for(k in options.data){
            //     urlParams.append(k, options.data[k]);
            // }
            

            // 用户
			var user=window.$utils.uniapi.getStorageSync("user");
			//console.log("axios2",user);
			var refreshToken="";
			if(!!user==true && user!=null && typeof user.id!='undefined'){
				options.data.token = user.token;
				//resolve( { code: "1000", msg: "尚未登录,token空", data:"" } );
				//return;
				refreshToken=user.refreshToken;
			}
			
			//获取店数据
			var selectedShop = window.$utils.uniapi.getStorageSync("selectedShop") || null; //{storeCode:'0008',storeName:'东湖店'}
			options.data.shopId = selectedShop!=null?selectedShop.id:"";
			
			//appId
			options.data.appId = window.$config.appId;
            
            //创建用户时传递fromUid
            if(options.url==window.$config.url.createUserByWxmp
                || options.url==window.$config.url.doLogin
                ){
                var fromUid=window.$utils.uniapi.getStorageSync("fromUid") || "";
                if(!!fromUid==true)options.data.fromUid = fromUid;
            }
            
			
			//请求作业
			if(!!options.url==false 
                // || (options.url.indexOf("http") != 0 && options.url.indexOf("//") != 0)
                ){
				resolve( { code: window.$config.resCode.UNSUCCESS, msg: "缺少url" ,data:"" });return;
			}

            
            let httpDefaultOpts = { //http默认配置
                method:"post",
                url: options.url,
                //params:options.data //Object.assign(params),//用于get方式
                data:qs.stringify(options.data) //urlParams //options.data //JSON.stringify(options.data) //用于post方式
            };
            console.log("start request for "+options.url);
            instance(httpDefaultOpts)
                .then(response => { //then 请求成功之后进行什么操作
                    console.log("axios response: "+JSON.stringify(response.data)+ " for "+options.url);
                    resolve(response.data);return;//把请求到的数据发到引用请求的地方
                })
                .catch(error => {
                    //console.log('请求异常信息=>：' + options.params + '\n' + '响应' + error);
                    console.log("axios error: "+error+" for "+options.url);
                    reject(error);return;
                })
           
        });
    },

    // 【测试】原生请求
    requestByXhr(){
        const xhr = new XMLHttpRequest()
        xhr.open('POST', 'https://ovege.cn/userservice/shop/list')
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
        xhr.withCredentials = true
        xhr.onload = function() {
        console.log('状态:', xhr.status)
        console.log('响应:', xhr.responseText)
        resolve()
        }
        xhr.onerror = function() {
        console.log('XHR 错误')
        resolve()
        }
        xhr.send('type=rgm_node&page=1&state=pass&appId=xs3df89a763c6bacff');
        resolve( { code: window.$config.resCode.UNSUCCESS, msg: "缺少0000url" ,data:"" });return;
        console.log('-----------------test end' )
    },

    /**
     * 请求服务端
     * @param {} options {url,data}
     */
    // old_request:function(options) {
    //     //window.log(options.data);
    //     return new Promise((resolve, reject) => {
    //         //测试待删.....
    //         //if(options.url.indexOf('showinfo')>0){resolve({data:{code:90,message:"未登录"}});return;}
    //         //获取店数据
    //         var storecode=""; //{storeCode:'0008',storeName:'东湖店'}
    //         window._callNativePage({ method:"getCurrStoreCode",data:{mustReturn:false,tips:""}, callback:function(d){
    //             window.log(d);
    //             if(typeof d=="string"){d=JSON.parse(d);}
    //             if(d && typeof d.storeCode!="undefined"){
    //                 storecode=d.storeCode;
    //             }
    //             //获取店完成,开始请求业务
    //             var token = window.localStorage.getItem('token') || "";
    //             //if(channel!=32) token="";//非小程序则强制更新
    //             window.log("token："+token);
    //             if(typeof token=="undefined" || token==null || token=="" || token.length<10){
    //                 //获取token
    //                 window._callNativePage({ method:"getToken",data:{}, callback:function(d){ 
    //                     //window.log("获取token返回："+d);
    //                     if(d){
    //                         if(typeof d=="string"){d=JSON.parse(d);  }
    //                         token=d.value;
    //                         if(typeof token=="undefined" || token==null || token=="" || token.length<10){
    //                             resolve({data:{code:90,message:"未登录"}});return;
    //                         }
    //                         window.localStorage.setItem('token',token);
    //                         //var params = options.params;//?深拷贝
    //                         var sign_str = "";//tools.sign(params); //签名
    //                         const instance = axios.create({
    //                             baseURL: baseURL,
    //                             timeout: 8000,
    //                             //instance创建一个axios实例，可以自定义配置，可在 axios文档中查看详情
    //                             //所有的请求都会带上这些配置，比如全局都要用的身份信息等。
    //                             headers: { //所需的信息放到header头中
    //                                 "Content-Type": contentType,
    //                                 //"X-LOCALE":language,
    //                                 "cl-opchannel":channel,
    //                                 "cl-aeontoken":token,
    //                                 'cl-storecode':storecode
    //                             },
    //                         });
    //                         // // //参数处理
    //                         // let urlParams = new URLSearchParams();
    //                         // for(k in options.data){
    //                         //     urlParams.append(k, options.data[k]);
    //                         // }
    //                         let httpDefaultOpts = { //http默认配置
    //                             method:"post",
    //                             url: options.url,
    //                             //params:options.data //Object.assign(params),//用于get方式
    //                             data:qs.stringify(options.data) //urlParams //options.data //JSON.stringify(options.data) //用于post方式
    //                         };
    //                         window.log("start request for "+options.url);
    //                         instance(httpDefaultOpts)
    //                             .then(response => { //then 请求成功之后进行什么操作
    //                                 window.log("axios response: "+JSON.stringify(response.data)+ " for "+options.url);
    //                                 resolve(response);return;//把请求到的数据发到引用请求的地方
    //                             })
    //                             .catch(error => {
    //                                 //console.log('请求异常信息=>：' + options.params + '\n' + '响应' + error);
    //                                 window.log("axios error: "+error+" for "+options.url);
    //                                 reject(error);return;
    //                             })
    //                     }else{
    //                         resolve({data:{code:90,message:"未登录"}});return;
    //                     }
    //                 }});
    //             }else{
    //                 //var params = options.params;//?深拷贝
    //                 var sign_str = "";//tools.sign(params); //签名
    //                 const instance = axios.create({
    //                     baseURL: baseURL,
    //                     timeout: 8000,
    //                     //instance创建一个axios实例，可以自定义配置，可在 axios文档中查看详情
    //                     //所有的请求都会带上这些配置，比如全局都要用的身份信息等。
    //                     headers: { //所需的信息放到header头中
    //                         "Content-Type": contentType,
    //                         //"X-LOCALE":language,
    //                         "cl-opchannel":channel,
    //                         "cl-aeontoken":token,
    //                         'cl-storecode':storecode
    //                     },
    //                 });
    //                 let httpDefaultOpts = { //http默认配置
    //                     method:"post",
    //                     url: options.url,
    //                     //params:Object.assign(params),
    //                     data:qs.stringify(options.data) //options.data
    //                 };
    //                 window.log("start request for "+options.url);
    //                 instance(httpDefaultOpts)
    //                     .then(response => {//then 请求成功之后进行什么操作
    //                         window.log("axios success2 : "+JSON.stringify(response.data)+" for "+options.url);
    //                         resolve(response);return;//把请求到的数据发到引用请求的地方
    //                     })
    //                     .catch(error => {
    //                         window.log("axios error2 : "+error+" for "+options.url);
    //                         reject(error);return;
    //                     })
    //             }
    //         }});
    //     });
    // }

    
}


// WEBPACK FOOTER //
// ./src/utils/myaxios.js